// Import global utils
import { isDefined } from '@automator/shared/utils/is-defined';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// Import utilities
import { updateConditionPostData } from './';
import { sanitizeFieldAttributes } from '@automator/builder/_legacy/js/field/utilities';
import { restCall } from '@automator/builder/_legacy/js/common/utilities';

/**
 * Does a REST call to get the fields of a condition
 *
 * @param {Object} options                 The options
 * @param {String} options.integrationCode The unique code of the integration
 * @param {String} options.conditionCode   The unique code of the condition
 * @return {Promise}                       TRUE if it was successful
 */
const getAndSaveConditionFields = ( { integrationCode, conditionCode } ) => {
	return new Promise( ( resolve, reject ) => {

		// Do REST call to get the fields
		restCall(
			'actions_conditions_fields',

			// Data
			{
				integration: integrationCode,
				code: conditionCode
			},

			// On success
			( response ) => {
				// Check if the fields are defined
				if ( ! response.success || ! isDefined( response.fields ) ) {
					return reject( new Error( escapeHTML( __( "Something went wrong. We couldn't get the fields.", 'uncanny-automator' ) ) ) );
				}

				// Parse fields
				const fields = response.fields.map( ( fieldAttributes ) => {
					// Add the item type
					fieldAttributes.itemType = 'condition';

					// Add the integration ID
					fieldAttributes.integrationId = integrationCode;

					// Sanitize and return the attributes
					return sanitizeFieldAttributes( fieldAttributes );
				} );

				// Update the condition post data
				updateConditionPostData( {
					integrationCode: integrationCode,
					conditionCode: conditionCode,
					updates: {
						fields: fields
					}
				} );

				// Check if it was successful
				return resolve( fields );
			},

			// On fail
			() => {
				return reject( new Error( escapeHTML( __( "Something went wrong. We couldn't get the fields.", 'uncanny-automator' ) ) ) );
			},

			// Options
			{
				requiresRecipesObject: false,
				renderUI: false,
			}
		);

	} );
}

export default getAndSaveConditionFields;
